import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { updateFranchiseEnabledSettings } from '@app/services/franchise';

interface UpdateFranchiseSettingsModalProps {
  show: boolean;
  handleClose: () => void;
  franchiseData: {
    id: number;
    name: string;
    enabled_review_session_notes?: boolean;
  };
  onSuccess: () => void;
}

const UpdateFranchiseSettingsModal: React.FC<UpdateFranchiseSettingsModalProps> = ({
  show,
  handleClose,
  franchiseData,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);
  const [enabledReviewSessionNotes, setEnabledReviewSessionNotes] = useState(false);

  useEffect(() => {
    if (franchiseData) {
      setEnabledReviewSessionNotes(franchiseData.enabled_review_session_notes || false);
    }
  }, [franchiseData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        enabled_review_session_notes: enabledReviewSessionNotes
      };

      const response = await updateFranchiseEnabledSettings(franchiseData.id, payload);

      if (response?.success) {
        toast.success('Franchise settings updated successfully');
        onSuccess();
        handleClose();
      } else {
        toast.error(response?.message || 'Failed to update franchise settings');
      }
    } catch (error: any) {
      toast.error(error?.message || 'Internal Server Error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Update Franchise Settings</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <h5>{franchiseData?.name}</h5>
          </div>
          
          <div className="form-group">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="enabledReviewSessionNotes"
                checked={enabledReviewSessionNotes}
                onChange={(e) => setEnabledReviewSessionNotes(e.target.checked)}
              />
              <label className="custom-control-label" htmlFor="enabledReviewSessionNotes">
                Enable Review of Session Notes
              </label>
            </div>
            <small className="form-text text-muted">
              When enabled, session notes will require review before being published
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2"></i>
                Updating...
              </>
            ) : (
              'Update Settings'
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default UpdateFranchiseSettingsModal;
